import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_dh5r7x4rex: FaireCollectionEntity = {
  token: "pbc_dh5r7x4rex",
  type: "collection",
  name: "Mardi Gras",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b75ac30fd9bc7fa891fa0fc385e0034d0c7cc5a00741e9a746a016fa19073796.jpeg",
  itemCount: 29,
  description: "Catch beads and memories in our new designs for Mardi Gras! ",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:39.674Z",
    importedBy: "entity-db-import-collections",
  },
};
